export default __webpack_public_path__ + "static/media/element_54.34c8a9a9.jpg";